import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgMultiplePerson = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M7 11a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM17 11a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm0 2a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
      <path d="M7 16a6 6 0 0 1 6 6 1 1 0 0 1-2 0 4 4 0 0 0-8 0 1 1 0 0 1-2 0 6 6 0 0 1 6-6Z" />
      <path d="M17 16a6 6 0 0 1 6 6 1 1 0 0 1-2 0 4 4 0 0 0-8 0 1 1 0 0 1-2 0 6 6 0 0 1 6-6ZM12 6a6 6 0 0 1 6 6 1 1 0 0 1-2 0 4 4 0 0 0-8 0 1 1 0 0 1-2 0 6 6 0 0 1 6-6Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgMultiplePerson)
const Memo = memo(ForwardRef)
export default Memo
